var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dynamic-object-form-structure", {
    attrs: {
      "object-uuid": _vm.objectUUID,
      "object-layer": _vm.objectLayer,
      "loading-structure": _vm.loadingStructure,
      "loading-save": _vm.loadingSave,
      "permission-name": _vm.form.permission,
      "object-type-translation-key": _vm.form.name_translation,
      tabs: _vm.visibleTabs,
      "active-tab": _vm.activeTab,
      "action-type": _vm.actionType,
      saveIsDisabled: !_vm.required.filled,
      "map-element": _vm.$parent.$refs.formsContainer,
      "previous-pos-x": _vm.previousPosX,
      "previous-pos-y": _vm.previousPosY,
      "data-was-changed": _vm.dataWasChanged,
      "fields-still-need-filled": _vm.required.stillNeedFilled,
      "object-data": _vm.objectData
    },
    on: {
      updateActiveTab: function($event) {
        _vm.activeTab = $event
      },
      changeViewMode: _vm.changeViewModeOfObject,
      openDetails: _vm.openDetails,
      refresh: _vm.refresh,
      clearData: _vm.clearData,
      save: _vm.saveObject,
      close: _vm.closeForm
    },
    scopedSlots: _vm._u([
      {
        key: "formFields",
        fn: function() {
          return [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.visibleTabs[_vm.activeTab].type === "form",
                    expression: "visibleTabs[activeTab].type === 'form'"
                  }
                ],
                staticClass: "form tab-content"
              },
              [
                _vm._l(_vm.visibleTabs[_vm.activeTab].fields, function(field) {
                  return [
                    field.var_name === "bl_type" &&
                    field.select_list_name === "list_blockage_obstruction_type"
                      ? _c(
                          "input-field",
                          {
                            key:
                              _vm.visibleTabs[_vm.activeTab].label +
                              field.label +
                              field.order,
                            attrs: {
                              value: _vm.getValueInObject(
                                field.var_name,
                                field.input_type
                              ),
                              label: field.label_client
                                ? field.label_client
                                : field.label,
                              "variable-name": field.var_name,
                              inputType: "other",
                              size: field.size,
                              required: field.required,
                              "required-filled": _vm.required.filled,
                              hide: field.hide,
                              fieldDisabled: field.disable,
                              tabDisabled: !_vm.userCanEditTabContent(
                                _vm.visibleTabs[_vm.activeTab]
                              ),
                              formDisabled: _vm.readOnly
                            }
                          },
                          [
                            _c(
                              "div",
                              [
                                _c("treeselect", {
                                  staticClass: "form-input-select",
                                  attrs: {
                                    value: _vm.objectData.bl_type,
                                    options: _vm.blockageTypeOptions,
                                    normalizer:
                                      _vm.blockageTypeOptionsNormalizer,
                                    disabled:
                                      _vm.readOnly ||
                                      !_vm.userCanEditTabContent(
                                        _vm.visibleTabs[_vm.activeTab]
                                      ) ||
                                      field.disable,
                                    disableFuzzyMatching: ""
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.setValueInObject(
                                        field.var_name,
                                        $event
                                      )
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _c("input-field", {
                          key:
                            _vm.visibleTabs[_vm.activeTab].label +
                            field.label +
                            field.order,
                          ref: "formInputField",
                          refInFor: true,
                          attrs: {
                            value: _vm.getValueInObject(
                              field.var_name,
                              field.input_type
                            ),
                            label: field.label_client
                              ? field.label_client
                              : field.label,
                            "variable-name": field.var_name,
                            inputType: field.input_type,
                            size: field.size,
                            required: field.required,
                            "required-filled": _vm.required.filled,
                            selectOptions: field.select_list_name,
                            radioOptions: field.radio_options,
                            fieldDisabled: field.disable,
                            tabDisabled: !_vm.userCanEditTabContent(
                              _vm.visibleTabs[_vm.activeTab]
                            ),
                            formDisabled: _vm.readOnly,
                            hide: field.hide,
                            checkboxOptions: field.checkbox_options,
                            "object-data": _vm.objectData,
                            labelIsLocked: _vm.objectData.bl_label_locked,
                            "user-can-unlock-label": !_vm.userHasFibercloudPermission(
                              _vm.form.permission + "_manage_label"
                            )
                          },
                          on: {
                            input: function($event) {
                              return _vm.setValueInObject(
                                field.var_name,
                                $event,
                                field.input_type
                              )
                            },
                            "toggle-label-lock": _vm.changeLabelMode,
                            updateCheckboxValue: function($event) {
                              return _vm.updateCheckboxValue($event)
                            },
                            removePhoto: function($event) {
                              return _vm.addToPhotosToRemove($event)
                            }
                          }
                        })
                  ]
                })
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.visibleTabs[_vm.activeTab].code ===
                      "blockage_specific_fields",
                    expression:
                      "visibleTabs[activeTab].code === 'blockage_specific_fields'"
                  }
                ],
                staticClass: "form tab-content"
              },
              _vm._l(_vm.obstructionTypeSpecificFields, function(field) {
                return _c("input-field", {
                  key: field.var_name,
                  attrs: {
                    value: _vm.getValueInObject(
                      field.var_name,
                      field.input_type,
                      "blockage_specific_fields"
                    ),
                    label: field.label,
                    "variable-name": field.var_name,
                    "input-type": field.input_type,
                    size: "small",
                    required: field.required,
                    "required-filled": _vm.required.filled,
                    radioOptions: field.radio_options,
                    checkboxOptions: field.checkbox_options,
                    tabDisabled: !_vm.userCanEditTabContent(
                      _vm.visibleTabs[_vm.activeTab]
                    ),
                    formDisabled: _vm.readOnly,
                    objectData: _vm.objectData
                  },
                  on: {
                    input: function($event) {
                      return _vm.setValueInObject(
                        field.var_name,
                        $event,
                        "blockage_specific_fields"
                      )
                    },
                    updateCheckboxValue: function($event) {
                      return _vm.updateCheckboxValue(
                        $event,
                        "blockage_specific_fields"
                      )
                    }
                  }
                })
              }),
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8eda2cb6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8eda2cb6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/ObjectForms/BlockageForm.vue
// module id = null
// module chunks = 